// extracted by mini-css-extract-plugin
module.exports = {"option":"option-with-icon__option___39hfh","icon":"option-with-icon__icon___IF4KK","label":"option-with-icon__label___3VL8_"};